import { isValidOrgNumber, isValidSsn } from '@common/utils';
const {
  createContext,
  useContext,
  useState
} = React;
const FormContext = createContext();
export const useFormContext = () => useContext(FormContext);
const initialFormData = {
  companyName: '',
  customersPerWeek: '',
  orgNumber: '',
  signatoryName: '',
  signatorySsn: '',
  signatoryMobilePhone: '',
  signatoryEmail: '',
  storeName: '',
  storeAddress: '',
  storePostalCode: '',
  storeCity: '',
  storePhone: '',
  storeMobilePhone: '',
  storeEmail: '',
  contactName: '',
  contactMobilePhone: '',
  contactEmail: '',
  turnoverMSek: '',
  manualRegisters: '',
  hoursWeekdays: '',
  hoursSaturday: '',
  hoursSunday: '',
  consent: false,
  sellTypeCompleteRetailer: false,
  sellTypeTickets: false,
  deliveryAddress: '',
  deliveryPostalCode: '',
  deliveryCity: '',
  prospectChain: '',
  comment: '',
  inStoreRegisters: '',
  reconciliationRegisters: '',
  selfCheckoutRegisters: ''
};
export const FormProvider = ({
  children
}) => {
  const [formData, setFormData] = useState(initialFormData);
  const [formErrors, setFormErrors] = useState({});
  const requiredFields = ['companyName', 'customersPerWeek', 'orgNumber', 'signatoryName', 'signatorySsn', 'signatoryMobilePhone', 'signatoryEmail', 'storeName', 'storeAddress', 'storePostalCode', 'storeCity', 'storePhone', 'storeMobilePhone', 'storeEmail', 'contactName', 'contactMobilePhone', 'contactEmail', 'turnoverMSek', 'manualRegisters', 'hoursWeekdays', 'hoursSaturday', 'hoursSunday', 'consent'];
  const updateField = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setFormErrors(prev => {
      const {
        [field]: _,
        ...rest
      } = prev;
      return rest;
    });
  };
  const resetForm = () => {
    setFormData(initialFormData);
    setFormErrors({});
  };
  const validateForm = () => {
    const errors = {};
    const errorTypes = [];
    const missingRequiredFields = requiredFields.filter(field => {
      const value = formData[field];
      return value === undefined || value === null || value === '' || typeof value === 'boolean' && value === false;
    });
    if (missingRequiredFields.length > 0) {
      missingRequiredFields.forEach(field => {
        errors[field] = 'Detta fält är obligatoriskt';
      });
      errorTypes.push('required');
    }
    if (formData.orgNumber && !isValidOrgNumber(formData.orgNumber)) {
      errors.orgNumber = 'Ogiltigt organisationsnummer';
      errorTypes.push('orgNumber');
    }
    if (formData.signatorySsn && !isValidSsn(formData.signatorySsn)) {
      errors.signatorySsn = 'Ogiltigt personnummer';
      errorTypes.push('ssn');
    }
    if (!formData.sellTypeCompleteRetailer && !formData.sellTypeTickets) {
      errors.ombudType = 'Detta fält är obligatoriskt';
      if (!errorTypes.includes('required')) {
        errorTypes.push('required');
      }
    }
    setFormErrors(errors);
    return errorTypes;
  };
  return <FormContext.Provider value={{
    formData,
    formErrors,
    updateField,
    resetForm,
    validateForm,
    setFormData
  }}>
      {children}
    </FormContext.Provider>;
};